import { render, staticRenderFns } from "./CustomerCorporateWalletCard.vue?vue&type=template&id=5558ce5a&scoped=true"
import script from "./CustomerCorporateWalletCard.vue?vue&type=script&lang=js"
export * from "./CustomerCorporateWalletCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerCorporateWalletCard.vue?vue&type=style&index=0&id=5558ce5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5558ce5a",
  null
  
)

export default component.exports